import { Validator } from './Validator';
import { ReactError } from 'consts/ReactError';

export type FormErrors = {
	lastname: string;
	firstname: string;
	mailaddress: string;
	isNotRobot: string;
};

export const initialFormErrors: FormErrors = {
	lastname: '',
	firstname: '',
	mailaddress: '',
	isNotRobot: '',
};

/**
 * 項目ごとにバリデーションチェックをし、エラーメッセージを返す
 * @param name 項目名
 * @param value 値
 * @param displayType 表示タイプ 1：表示＆必須入力, 2：表示＆任意入力
 * @returns エラーメッセージ or 空文字
 */
export const getErrorMessage = <T>(name: string, value: T): string => {
	const validator = new Validator(value);
	switch (name) {
		case 'lastname':
		case 'firstname':
			return validator.require().charTypeFullWidth(ReactError.E0007).end();
		case 'mailaddress':
			return validator.require().charTypeEmail().end();
		default:
			return '';
	}
};
